module.exports = __webpack_public_path__ + "img/tile_championLA.fbd67c59.jpg";